import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import BaseStorage from '../base-storage';
import { NOT_FOUND } from '../utils/constants';

var NullStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(NullStrategy, _BaseStorage);

  function NullStrategy() {
    return _BaseStorage.apply(this, arguments) || this;
  }

  var _proto = NullStrategy.prototype;

  _proto.setItem = /*#__PURE__*/function () {
    var _setItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function setItem() {
      return _setItem.apply(this, arguments);
    }

    return setItem;
  }();

  _proto.getItem = function getItem() {
    return Promise.reject(NOT_FOUND);
  };

  _proto.removeItem = function removeItem() {
    return Promise.resolve();
  };

  _proto.getAllItems = function getAllItems() {
    return Promise.resolve({});
  };

  return NullStrategy;
}(BaseStorage);

export { NullStrategy as default };